/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CategoryWithStructure } from './CategoryWithStructure';
import {
    CategoryWithStructureFromJSON,
    CategoryWithStructureFromJSONTyped,
    CategoryWithStructureToJSON,
    CategoryWithStructureToJSONTyped,
} from './CategoryWithStructure';

/**
 * 
 * @export
 * @interface TournamentStructure
 */
export interface TournamentStructure {
    /**
     * 
     * @type {string}
     * @memberof TournamentStructure
     */
    tournamentId?: string;
    /**
     * 
     * @type {Array<CategoryWithStructure>}
     * @memberof TournamentStructure
     */
    categories?: Array<CategoryWithStructure>;
}

/**
 * Check if a given object implements the TournamentStructure interface.
 */
export function instanceOfTournamentStructure(value: object): value is TournamentStructure {
    return true;
}

export function TournamentStructureFromJSON(json: any): TournamentStructure {
    return TournamentStructureFromJSONTyped(json, false);
}

export function TournamentStructureFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentStructure {
    if (json == null) {
        return json;
    }
    return {
        
        'tournamentId': json['tournamentId'] == null ? undefined : json['tournamentId'],
        'categories': json['categories'] == null ? undefined : ((json['categories'] as Array<any>).map(CategoryWithStructureFromJSON)),
    };
}

export function TournamentStructureToJSON(json: any): TournamentStructure {
    return TournamentStructureToJSONTyped(json, false);
}

export function TournamentStructureToJSONTyped(value?: TournamentStructure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tournamentId': value['tournamentId'],
        'categories': value['categories'] == null ? undefined : ((value['categories'] as Array<any>).map(CategoryWithStructureToJSON)),
    };
}

